var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBasketCorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1026 6.68323L11.9494 4.622C11.9267 4.272 11.6354 4 11.2847 4H3.19872C2.84738 4 2.55672 4.272 2.53338 4.622L2.00338 12.578C1.95205 13.3473 2.56205 14 3.33338 14H6.00005",
    stroke: "#3E444A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24133 5.33398V3.33398C5.24133 2.22932 6.13667 1.33398 7.24133 1.33398V1.33398C8.346 1.33398 9.24133 2.22932 9.24133 3.33398V5.33398",
    stroke: "#3E444A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7338 9.70165V9.21865C11.7338 8.59756 11.2557 8.08984 10.6722 8.08984C10.0887 8.08984 9.61108 8.59756 9.61108 9.21865V9.70165",
    stroke: "#3E444A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3334 9.70312H9.01199C8.7353 9.70312 8.50373 9.91373 8.47741 10.1894L8.16955 13.413C8.13893 13.7283 8.38714 14.0013 8.70413 14.0013H12.6412C12.9582 14.0013 13.2065 13.7283 13.1758 13.413L12.868 10.1894C12.8416 9.91373 12.6101 9.70313 12.3334 9.70313V9.70312Z",
    stroke: "#3E444A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketCorIcon);
export default __webpack_public_path__ + "static/media/basketCorIcon.dab8deeb1cc70103e60944bda46f38a0.svg";
export { ForwardRef as ReactComponent };